import { render, staticRenderFns } from "./Analisis_cantidad.vue?vue&type=template&id=522b8eac"
import script from "./Analisis_cantidad.vue?vue&type=script&lang=js"
export * from "./Analisis_cantidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports